import React from "react";
import "./Articles.css";

const Articles = () => {
  return (
    <section className="article-section">
      <h2 className="article-heading">Articles</h2>
      <div className="article-card">
        <div className="article-image-wrapper">
          <img
            src="./assets/Blog.webp"
            alt="C-Section Recovery"
            className="article-image"
          />
          <div className="article-overlay"></div>
        </div>
        <div className="article-content">
          <h3 className="article-title">C-Section Recovery</h3>
          <p className="article-description">
            Learn about the procedure, recovery, and scar care journey with
            RemeCure Scar C-section.
          </p>
          <p className="article-date">February 25, 2025</p>
        </div>
      </div>
    </section>
  );
};

export default Articles;
